// import { useStorage } from '../hooks/use-storage';
// import { useAuthRejectedModal } from '../screens/order/auth-rejected-modal';
import { useOAuthModal } from '../screens/order/oauth-modal';

function useAuthWorkflow() {
  // const { spotRef } = useStorage();
  const { prepareOAuthModal, showOAuthModal } = useOAuthModal();
  // const { showAuthRejectedModal } = useAuthRejectedModal();

  async function prepare() {
    await prepareOAuthModal();
  }

  async function show(
    {
      prepareOnPreConfirm,
      prepareOnPreDeny,
      showName,
      // forceShowAuthRejectedModal,
    }
    // = { forceShowAuthRejectedModal: false }
  ) {
    const result = await showOAuthModal({
      prepareOnPreConfirm,
      prepareOnPreDeny,
      showName,
    });

    // if (
    //   result.isDismissed &&
    //   (spotRef.current?.prepaid || forceShowAuthRejectedModal)
    // ) {
    //   await showAuthRejectedModal();
    // }

    return result;
  }

  return {
    prepareAuthWorkflow: prepare,
    showAuthWorkflow: show,
  };
}

export { useAuthWorkflow };
